export default "__VITE_ASSET__BNNdIWGq__"